/**
 * @file: 撤销
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../../../stageStatus';
import * as UIToolkit from '../../../UIToolkit/index';
import { historyPop } from './pop';
import { addStackOut } from '../add';
import { removeStackOut } from '../remove';
import { numberKeyStackOut } from '../numberKey';
import { selectUpdateStackOut } from '../selectUpdate';
import { updateByApiStackOut } from '../updateByApi';
import { layerAlignStackOut } from '../layerAlign';
import { shortMoveStackOut } from '../shortMove';
import { shelfDragMoveStackOut } from '../shelfDragMove';
import { layerDragMoveStackOut } from '../layerDragMove';
import { goodsDragMoveStackOut } from '../goodsDragMove';
import { textareaDragMoveStackOut } from '../textareaDragMove';
import { bafflePlateDragMoveStackOut } from '../bafflePlateDragMove';
import { addSubStackOut } from '../addSub';

let doing: boolean = false;

async function stackOut(): Promise<any> {
    // 卧柜暂不支持
    if (StageStatus.isTopFace()) {
        UIToolkit.tips('卧柜暂不支持回退操作');
        return;
    }

    if (doing) {
        UIToolkit.tips('回退中，请稍后');
        return;
    }
    doing = true;
    let stackOutItem: StackOutItem|null = await historyPop();

    if (!stackOutItem) {
        UIToolkit.tips('已无上一步');
        doing = false;
        return;
    }

    try {
        await revoke(stackOutItem);
        doing = false;
    }
    catch(err) {
        doing = false;
    }
}

async function revoke(stackOutItem: StackOutItem|null): Promise<void> {
    switch(stackOutItem.type) {
        case 'add':
            await addStackOut(stackOutItem);
            break;

        case 'remove':
            await removeStackOut(stackOutItem);
            break;

        case 'quickSurface':
            await numberKeyStackOut(stackOutItem);
            break;

        case 'selectUpdate':
            await selectUpdateStackOut(stackOutItem);
            break;

        case 'updateByApi':
            await updateByApiStackOut(stackOutItem);
            break;

        case 'layerAlign':
            await layerAlignStackOut(stackOutItem);
            break;

        case 'shortMove':
            await shortMoveStackOut(stackOutItem);
            break;

        case 'shelfDragMove':
            await shelfDragMoveStackOut(stackOutItem);
            break;

        case 'layerDragMove':
            await layerDragMoveStackOut(stackOutItem);
            break;

        case 'goodsDragMove':
            await goodsDragMoveStackOut(stackOutItem);
            break;

        case 'textareaDragMove':
            await textareaDragMoveStackOut(stackOutItem);
            break;

        case 'bafflePlateDragMove':
            await bafflePlateDragMoveStackOut(stackOutItem);
            break;

        case 'addSub':
            await addSubStackOut(stackOutItem);
            break;

        default:
            break;
    }
}

export {
    stackOut
};
